import { ChangeEvent } from 'react'
import { useTranslation } from 'next-i18next'

import { Location } from '~/types/booking'
import { SelectBoxHomGradient } from '~/components/SelectBoxHomGradient'

const CITIES = Object.values(Location).filter((elem) => elem !== Location.ONLINE)

export default function SelectLocation<T extends Location | null>({
  onChange,
  location,
}: {
  onChange: (location: T) => void
  location: T
}): React.ReactElement {
  const { t } = useTranslation(['booking', 'generics'])

  const handleOnChange = (event: ChangeEvent<HTMLSelectElement>): void => {
    onChange((event.target.value || null) as T)
  }

  return (
    <div className="w-full space-y-2 flex flex-col items-center">
      <SelectBoxHomGradient isSelected name="location" onChange={handleOnChange} value={location ?? ''}>
        <option value={Location.ONLINE}>{t('booking:onlineTutoring')}</option>
        {CITIES.map((elem) => (
          <option key={elem} value={elem}>
            {t(`booking:cities.${elem}`)}
          </option>
        ))}
      </SelectBoxHomGradient>
    </div>
  )
}
